import { compact } from "lodash";
import { Node_Type } from "./../ricos-types";
import {
  decorateComponentWithProps,
  INSERT_PLUGIN_BUTTONS,
  TOOLBARS
} from "./../editor-common";
import { SoundCloudIcon, SpotifyIcon } from "./../ui-components";
import { audioModals } from "./consts";
import { RICOS_DEFAULTS } from "./defaults";
import AudioInsertPluginIcon from "./icons/InsertPluginIcon";
import { InsertModal } from "./modals/InsertModal";
import { audioButtonsTypes } from "./types";
const toolbarsToAddIn = [
  TOOLBARS.FOOTER,
  TOOLBARS.SIDE,
  TOOLBARS.MOBILE
];
const getAddButtons = (config, services) => {
  const {
    exposeButtons = [audioButtonsTypes.audio],
    handleFileSelection,
    handleFileUpload,
    disableDownload = true,
    fetchData
  } = config || {};
  const modalBaseProps = {
    handleFileSelection,
    handleFileUpload,
    fetchData
  };
  const modalConfigProps = {
    dragHandleSelector: "[data-drag-handler]",
    enableDrag: !services.context.isMobile,
    withTransition: true,
    noPadding: true,
    layout: services.context.isMobile ? "fullscreen" : "floating",
    type: "exclusive"
  };
  const buttonsMap = {
    [audioButtonsTypes.audio]: {
      id: `${Node_Type.AUDIO}.audio`,
      label: INSERT_PLUGIN_BUTTONS.AUDIO,
      dataHook: INSERT_PLUGIN_BUTTONS.AUDIO,
      icon: AudioInsertPluginIcon,
      tooltip: "AudioPlugin_InsertButton_Tooltip",
      toolbars: toolbarsToAddIn,
      command: () => true,
      modal: {
        id: audioModals.insertAudio,
        Component: decorateComponentWithProps(InsertModal, {
          componentData: { ...RICOS_DEFAULTS, disableDownload },
          modalId: audioModals.insertAudio,
          ...modalBaseProps
        }),
        ...modalConfigProps
      },
      menuConfig: {
        tags: "Audio_plugin_search_tags"
      }
    },
    [audioButtonsTypes.soundCloud]: {
      id: `${Node_Type.AUDIO}.soundCloud`,
      label: INSERT_PLUGIN_BUTTONS.SOUND_CLOUD,
      dataHook: INSERT_PLUGIN_BUTTONS.SOUND_CLOUD,
      icon: SoundCloudIcon,
      tooltip: "SoundCloudPlugin_InsertButton_Tooltip",
      toolbars: toolbarsToAddIn,
      command: () => true,
      modal: {
        id: audioModals.insertSoundCloud,
        Component: decorateComponentWithProps(InsertModal, {
          componentData: { ...RICOS_DEFAULTS },
          modalId: audioModals.insertSoundCloud,
          embedType: true,
          ...modalBaseProps
        }),
        ...modalConfigProps
      },
      menuConfig: {
        tags: "SoundCloud_plugin_search_tags",
        group: "embed"
      }
    },
    [audioButtonsTypes.spotify]: {
      id: `${Node_Type.AUDIO}.spotify`,
      label: INSERT_PLUGIN_BUTTONS.SPOTIFY,
      dataHook: INSERT_PLUGIN_BUTTONS.SPOTIFY,
      icon: SpotifyIcon,
      tooltip: "Spotify_InsertButton_Tooltip",
      toolbars: toolbarsToAddIn,
      command: () => true,
      modal: {
        id: audioModals.insertSpotify,
        Component: decorateComponentWithProps(InsertModal, {
          componentData: { ...RICOS_DEFAULTS },
          modalId: audioModals.insertSpotify,
          embedType: true,
          ...modalBaseProps
        }),
        ...modalConfigProps
      },
      menuConfig: {
        tags: "AudioPlugin_InsertButton",
        group: "embed"
      }
    }
  };
  return compact(exposeButtons.map((buttonType) => buttonsMap[buttonType]));
};
export {
  getAddButtons,
  toolbarsToAddIn
};
//# sourceMappingURL=getAddButtons.js.map
